import Icon from '../components/Icon.vue'

Icon.register({
  'eye-slash': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M320 400c7.2-0.1 18.9-1.2 26-2.6l51.9 40.2c-25 6.5-51 10.5-77.9 10.5-122.9 0-230.3-71.6-284.5-177.4-1.9-3.8-3.5-10.3-3.5-14.6s1.6-10.8 3.5-14.6c10.2-20 22.9-38.3 36.7-55.6l104.9 81.1c5.7 74.4 67.1 133.1 142.9 133.1zM633.8 458.1c3.4 2.7 6.2 8.3 6.2 12.6 0 3-1.5 7.4-3.4 9.8l-19.6 25.3c-2.7 3.4-8.3 6.2-12.6 6.2-3 0-7.4-1.5-9.8-3.4l-588.4-454.7c-3.4-2.7-6.2-8.3-6.2-12.6 0-3 1.5-7.4 3.4-9.8l19.6-25.3c2.7-3.4 8.3-6.2 12.6-6.2 3 0 7.4 1.5 9.8 3.4l127.2 98.3c38-20.8 104-37.6 147.3-37.7 122.9 0 230.3 71.6 284.5 177.4 1.9 3.8 3.5 10.3 3.5 14.6s-1.6 10.8-3.5 14.6c-16.8 32.7-53.2 78.4-81.3 102.1zM450.1 316.1c8.6-18.3 13.9-38.5 13.9-60.1v-0.1c0-79.4-64.5-143.9-143.9-143.9h-0.1c-28.5 0-69.3 14.9-91.2 33.1l73.6 56.9c0.7-2.7 1.4-7.2 1.5-10 0-8.6-4.2-21.3-9.3-28.2 7.2-2.1 19.1-3.8 26.6-3.8 52.3 0 94.8 42.5 94.8 94.8 0 0.3 0 0.9 0 1.2-0.1 8.4-2.4 21.7-5.2 29.7z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/eye-slash.js
// module id = 1314
// module chunks = 0